import { render, staticRenderFns } from "./ContractorList.vue?vue&type=template&id=080def40&scoped=true&"
import script from "./ContractorList.vue?vue&type=script&lang=js&"
export * from "./ContractorList.vue?vue&type=script&lang=js&"
import style0 from "./ContractorList.vue?vue&type=style&index=0&id=080def40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080def40",
  null
  
)

export default component.exports